import { EditorSteps } from '../../../constants';
import type { DataStreamFilters } from '../../../hooks/useDataStreamFilters';
import type { StepWithCondition } from '../../../hooks/useTileEditorSteps';
import { DataStreamDisplayName } from './DataStreamDisplayName';
import { DataStreamStep } from './DataStreamStep';

/**
 * Create an object representing a data stream step.
 */
export const useDataStreamStep = (
    filters: DataStreamFilters,
    isSqlEnabled: boolean
): StepWithCondition<Record<string, unknown>, { dataStreamFilters: DataStreamFilters }> => {
    return {
        name: EditorSteps.dataStream,
        isEnabled: !isSqlEnabled,

        Sublabel: DataStreamDisplayName,
        sublabelProps: {},

        Content: DataStreamStep,
        contentProps: { dataStreamFilters: filters }
    };
};
